import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MapPin, Sun, Waves, Utensils } from 'lucide-react';

const Destination = () => {
  const highlights = [
    { icon: Sun, text: "Masser af solskinstimer" },
    { icon: Waves, text: "Brede sandstrande" },
    { icon: Utensils, text: "Autentisk spansk mad" },
    { icon: MapPin, text: "Nær historiske Cádiz" },
  ];

  return (
    <section id="destination" className="pt-32 pb-24 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-medium text-slate-900 mb-8 uppercase">
              Costa de la Luz – det autentiske Spanien
            </h2>
            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              Området omkring Cádiz, La Barrosa og Costa de la Luz byder på golf, brede strande, spansk kultur, friskfanget fisk, sherry fra Jerez og en mere rolig atmosfære end mange af de klassiske turistområder.
            </p>
            <p className="text-slate-600 text-lg leading-relaxed mb-10">
              Golf4Life beskriver selv området som autentisk Spanien nær Cádiz. Her finder du roen til at nyde spillet og de smukke omgivelser uden stress og jag.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-10">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-center gap-3 text-slate-700 font-medium">
                  <item.icon size={24} className="text-slate-900 shrink-0" />
                  {item.text}
                </div>
              ))}
            </div>
            
            <Link 
              to="/kontakt" 
              className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-[#39d14b] text-white font-medium text-lg hover:-translate-y-1 transition-all shadow-lg uppercase tracking-wider"
            >
              Få et uforpligtende tilbud
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative md:max-w-xl md:mx-auto lg:max-w-none"
          >
            <div className="rounded-3xl overflow-hidden shadow-2xl aspect-[4/5]">
              <img 
                src="https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/8f7178f9-f1d3-4173-83ca-8116b639a6a2.jpg" 
                alt="Sancti Petri Hills Golf" 
                className="w-full h-full object-cover"
              />
            </div>
            {/* Overlay badge */}
            <div className="absolute -top-6 -right-6 bg-white p-6 rounded-2xl shadow-xl border border-slate-100 hidden md:block">
              <p className="text-black font-medium text-2xl">20°C+</p>
              <p className="text-black text-sm">Gennemsnit i vinterhalvåret</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Destination;
